module.exports = __webpack_public_path__ + "img/down-right.9843cf3d.svg";